import { LotusDivider } from "./Ornaments";

/**
 * Breathing room between sections, marked with the lotus dinkus —
 * the page's chapters are separated the way a printed scripture
 * separates its cantos. The `from`/`to` props are kept for call-site
 * compatibility and set the strip's colour to match the section it
 * leads out of.
 */
export function SectionDivider({
  from = "cream",
}: {
  from?: "cream" | "cream-dark";
  to?: "cream" | "cream-dark";
}) {
  return (
    <div
      className="flex h-20 items-center justify-center md:h-24"
      style={{ background: `var(--color-${from})` }}
      aria-hidden
    >
      <LotusDivider />
    </div>
  );
}
